import { post } from '../../service';
import { UrlBuilder } from '../../urlBuilder';

export const getProcedures = async (page, pageSize) => {
  const builder = new UrlBuilder(`/admin/procedures/get-procedures`);

  try {
    const response = await post(builder.toString(), { pageNumber: page, perPage: pageSize });

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const createProcedure = async (payload) => {
  const builder = new UrlBuilder(`/admin/procedures/create-procedure`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const updateProcedure = async (payload) => {
  const builder = new UrlBuilder(`/admin/procedures/update-procedure`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const toggleProcedureActivity = async (payload) => {
  const builder = new UrlBuilder(`/admin/procedures/toggle-procedure-activity`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
